module.exports = __webpack_public_path__ + "img/relatorio.232c4d1e.svg";